/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery'
],
function(
    $
){

    /* == GLOBAL DECLERATIONS == */
    window.TouchMouseEvent = {
        DOWN: "touchmousedown",
        UP: "touchmouseup",
        MOVE: "touchmousemove"
    }

    /* == EVENT LISTENERS == */
    var onMouseEvent = function(event) {
        var type;

        switch (event.type) {
            case "mousedown": type = window.TouchMouseEvent.DOWN; break;
            case "mouseup":   type = window.TouchMouseEvent.UP;   break;
            case "mousemove": type = window.TouchMouseEvent.MOVE; break;
            default:
                return;
        }

        var touchMouseEvent = normalizeEvent(type, event, event.pageX, event.pageY);
        $(event.target).trigger(touchMouseEvent);
    }

    var onTouchEvent = function(event) {
        var type;

        switch (event.type) {
            case "touchstart": type = window.TouchMouseEvent.DOWN; break;
            case "touchend":   type = window.TouchMouseEvent.UP;   break;
            case "touchmove":  type = window.TouchMouseEvent.MOVE; break;
            default:
                return;
        }

        var touch = event.originalEvent.touches[0];
        var touchMouseEvent;

        if (type == window.TouchMouseEvent.UP)
            touchMouseEvent = normalizeEvent(type, event, null, null);
        else
            touchMouseEvent = normalizeEvent(type, event, touch.pageX, touch.pageY);

        $(event.target).trigger(touchMouseEvent);
    }

    /* == NORMALIZE == */
    var normalizeEvent = function(type, original, x, y) {
        return $.Event(type, {
            pageX: x,
            pageY: y,
            originalEvent: original
        });
    }

    /* == LISTEN TO ORIGINAL EVENT == */
    var jQueryDocument = $(document);

    if ("ontouchstart" in window) {
        jQueryDocument.on("touchstart", onTouchEvent);
        jQueryDocument.on("touchmove", onTouchEvent);
        jQueryDocument.on("touchend", onTouchEvent);
    } else {
        jQueryDocument.on("mousedown", onMouseEvent);
        jQueryDocument.on("mouseup", onMouseEvent);
        jQueryDocument.on("mousemove", onMouseEvent);
    }

    function initScrollTouchEvents() {
        var scrolling = false;

        $(document).off('.scrolltouch');

        $(document).on('touchend.scrolltouch', '.scrollTouch', function(e) {
            if (scrolling) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        });

        $(document).on("touchstart.scrolltouch", '.scrollTouch', function(){
            scrolling = false;
        });

        $(document).on("touchmove.scrolltouch", '.scrollTouch', function(){
            scrolling = true;
        });
    }

	return {
        init: function () {
            initScrollTouchEvents();
        },
		slide: function slide(selector, callback) {

			if (!selector) return;

			var startX, endX, startY, endY;
			var minDistance = 50;

			$(document).off('.slide').on('touchstart.slide touchend.slide touchmove.slide', selector, function(e) {
	        	var touches = e.originalEvent.touches;

	        	if (touches.length === 1) {
	        		if (e.type === 'touchstart') {
	        			startX = touches[0].clientX;
	        			startY = touches[0].clientY;
	        		}

	        		if (e.type === 'touchmove') {
	        			endX = touches[0].clientX;
	        			endY = touches[0].clientY;
	        		}
	        	}

	        	if (e.type === 'touchend' && callback && Math.abs(endX - startX) > minDistance) callback.call(this, {
	        		x: (endX > startX) ? 'right' : 'left',
	        		y: (endY > startY) ? 'down' : 'up'
	        	});
	        });
		}
	}

});

}.call(window));